import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card, Alert } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({
    identifier: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(''); // Clear error when user types
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const result = await login(formData.identifier, formData.password);
      
      if (result.success) {
        // Navigation will be handled by the App component based on user role
        if (result.user.role === 'admin') {
          navigate('/admin');
        } else {
          navigate('/employee');
        }
      } else {
        setError(result.message || 'Login failed');
      }
    } catch (error) {
      setError('An unexpected error occurred');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Container fluid className="px-3 d-flex align-items-center min-vh-100">
        <Row className="justify-content-center w-100">
          <Col lg={5} md={7} sm={10} xs={12}>
            <Card className="login-card shadow-lg mx-auto">
              <div className="login-header">
                <div className="mb-3">
                  <div className="logo mx-auto" style={{ width: '80px', height: '80px', background: 'white' }}>
                    <i className="fas fa-sign-in-alt text-primary"></i>
                  </div>
                </div>
                <h2 className="mb-2">Welcome Back</h2>
                <p className="mb-0 opacity-75">Sign in to your account</p>
              </div>
              
              <div className="login-body">
                {error && (
                  <Alert variant="danger" className="mb-3">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    {error}
                  </Alert>
                )}
                
                <Form onSubmit={handleSubmit}>
                  <div className="form-floating-custom mb-3">
                    <Form.Control
                      type="text"
                      name="identifier"
                      placeholder="Username, Email or Employee ID"
                      value={formData.identifier}
                      onChange={handleChange}
                      required
                      disabled={loading}
                      className="form-control-custom"
                    />
                    <Form.Label>
                      <i className="fas fa-user me-2"></i>
                      Username, Email or Employee ID
                    </Form.Label>
                  </div>
                  
                  <div className="form-floating-custom mb-4">
                    <Form.Control
                      type="password"
                      name="password"
                      placeholder="Password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                      disabled={loading}
                      className="form-control-custom"
                    />
                    <Form.Label>
                      <i className="fas fa-lock me-2"></i>
                      Password
                    </Form.Label>
                  </div>
                  
                  <Button
                    type="submit"
                    className="btn-primary-custom w-100 mb-3"
                    disabled={loading}
                    size="lg"
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Signing In...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-sign-in-alt me-2"></i>
                        Sign In
                      </>
                    )}
                  </Button>
                </Form>
              </div>
              
              <div className="login-footer">
                <Link 
                  to="/" 
                  className="text-decoration-none d-flex align-items-center justify-content-center"
                >
                  <i className="fas fa-arrow-left me-2"></i>
                  Back to Home
                </Link>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;